// extracted by mini-css-extract-plugin
export var copyBlock = "copyBlock-module--copy-block--DdCEY";